export default {
  field_from_api: {
    clue: {
      name: '线索数'
    },
    arrived: {
      name: '到店量'
    },
    deal: {
      name: '成交数'
    }
  },
  getData (params = {}) {
    this.$rest.dataAnalysis.getArriveAnalysis(params).then(res => {
      if (res.code === 0) {
        this.dataList = res.data
      } else {
        this.showToast(res.message)
      }
    })
  }
}
